import { type BaseMock } from './base-mock';

export class MockGenerator {
  static generate<
    Mocker extends BaseMock<object>,
    Interface = ReturnType<Mocker['serialise']>,
  >(
    type: {
      new (): Mocker;
    },
    overrides?: Partial<NoInfer<Interface>>
  ): Interface {
    const data: Mocker = new type();
    return { ...data.serialise(), ...overrides } as unknown as Interface;
  }
}
